/**
 * gotu-banner8.js
 * Controller for "O Palco Teatral Encantado" (Halloween 2026 - Den Goda Fen).
 * Handles theatrical act scene switching, scroll-triggered auto-play, and architectural countdown.
 */
(function () {
  'use strict';

  function initTheatreBanner() {
    var root = document.getElementById('gotu-theatre-root');
    if (!root) return;

    var tabs = root.querySelectorAll('.gotu-theatre-act-btn');
    var scenes = root.querySelectorAll('.gotu-theatre-scene');
    var actName = document.getElementById('gotu-theatre-act-name');
    var progressFill = document.getElementById('gotu-theatre-progress');

    var currentIndex = 0;
    var userInteracted = false;
    var isVisible = false;
    var autoPlayTimer = null;
    var animFrame = null;

    var acts = [
      'Ato I: Diabinho, Bruxa Estrelada & Caldeirão',
      'Ato II: Bebé Abóbora, Palhaço Circo & Frankenstein',
      'Ato III: Bruxas Encantadas & Capa Teia de Aranha',
      'Ato IV: Menino Esqueleto, Fantasma & Aranha'
    ];

    // Ensure all videos are properly configured for inline muted autoplay
    for (var vIdx = 0; vIdx < scenes.length; vIdx++) {
      var vid = scenes[vIdx].querySelector('video');
      if (vid) {
        vid.muted = true;
        vid.defaultMuted = true;
        vid.setAttribute('muted', '');
        vid.setAttribute('playsinline', '');
        vid.setAttribute('webkit-playsinline', '');
      }
    }

    function playActiveVideo(index) {
      for (var j = 0; j < scenes.length; j++) {
        var video = scenes[j].querySelector('video');
        if (j === index) {
          scenes[j].classList.add('is-active');
          if (video) {
            video.muted = true;
            video.currentTime = 0;
            var promise = video.play();
            if (promise !== undefined) {
              promise.catch(function () {});
            }
          }
        } else {
          scenes[j].classList.remove('is-active');
          if (video) {
            video.pause();
            video.currentTime = 0;
          }
        }
      }
    }

    function startProgressTracking() {
      if (animFrame) {
        cancelAnimationFrame(animFrame);
        animFrame = null;
      }
      if (autoPlayTimer) {
        clearTimeout(autoPlayTimer);
        autoPlayTimer = null;
      }

      if (!isVisible || userInteracted) {
        if (progressFill) {
          progressFill.style.width = '0%';
        }
        return;
      }

      var currentVideo = scenes[currentIndex] ? scenes[currentIndex].querySelector('video') : null;

      function updateProgress() {
        if (!isVisible || userInteracted) return;

        if (currentVideo && currentVideo.duration > 0) {
          var pct = Math.min(100, (currentVideo.currentTime / currentVideo.duration) * 100);
          if (progressFill) {
            progressFill.style.width = pct.toFixed(1) + '%';
          }
        }
        animFrame = requestAnimationFrame(updateProgress);
      }

      animFrame = requestAnimationFrame(updateProgress);

      // Fallback timer if ended event is delayed
      autoPlayTimer = setTimeout(function () {
        if (!isVisible || userInteracted) return;
        var next = (currentIndex + 1) % tabs.length;
        switchScene(next, false);
      }, 5300);
    }

    function switchScene(index, manual) {
      if (manual) {
        userInteracted = true;
      }
      currentIndex = index;

      for (var i = 0; i < tabs.length; i++) {
        if (i === index) {
          tabs[i].classList.add('is-active');
          tabs[i].setAttribute('aria-selected', 'true');
        } else {
          tabs[i].classList.remove('is-active');
          tabs[i].setAttribute('aria-selected', 'false');
        }
      }

      if (isVisible || manual) {
        playActiveVideo(index);
      }

      if (actName && acts[index]) {
        actName.textContent = acts[index];
      }

      startProgressTracking();
    }

    for (var k = 0; k < tabs.length; k++) {
      (function (idx) {
        tabs[idx].addEventListener('click', function () {
          switchScene(idx, true);
        });
      })(k);
    }

    // Attach ended event to each video to transition seamlessly
    for (var s = 0; s < scenes.length; s++) {
      (function (idx) {
        var v = scenes[idx].querySelector('video');
        if (v) {
          v.addEventListener('ended', function () {
            if (!userInteracted && isVisible && currentIndex === idx) {
              var next = (currentIndex + 1) % tabs.length;
              switchScene(next, false);
            }
          });
        }
      })(s);
    }

    // Live Architectural Countdown to September 27, 2026 23:59:59 Lisbon Time
    var daysEl = root.querySelector('#gotu-theatre-days');
    var hoursEl = root.querySelector('#gotu-theatre-hours');
    var minsEl = root.querySelector('#gotu-theatre-mins');
    var secsEl = root.querySelector('#gotu-theatre-secs');

    var deadlineMs = new Date('2026-09-27T23:59:59+01:00').getTime();

    function updateCountdown() {
      var now = Date.now();
      var diff = deadlineMs - now;

      if (diff <= 0) {
        if (daysEl) daysEl.textContent = '00';
        if (hoursEl) hoursEl.textContent = '00';
        if (minsEl) minsEl.textContent = '00';
        if (secsEl) secsEl.textContent = '00';
        return;
      }

      var d = Math.floor(diff / (1000 * 60 * 60 * 24));
      var h = Math.floor((diff / (1000 * 60 * 60)) % 24);
      var m = Math.floor((diff / (1000 * 60)) % 60);
      var s = Math.floor((diff / 1000) % 60);

      if (daysEl) daysEl.textContent = d < 10 ? '0' + d : d;
      if (hoursEl) hoursEl.textContent = h < 10 ? '0' + h : h;
      if (minsEl) minsEl.textContent = m < 10 ? '0' + m : m;
      if (secsEl) secsEl.textContent = s < 10 ? '0' + s : s;
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);

    // Scroll trigger: when user scrolls to the banner, IMMEDIATELY start video & progress
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          isVisible = entry.isIntersecting;
          if (isVisible) {
            playActiveVideo(currentIndex);
            startProgressTracking();
          } else {
            if (animFrame) {
              cancelAnimationFrame(animFrame);
              animFrame = null;
            }
            if (autoPlayTimer) {
              clearTimeout(autoPlayTimer);
              autoPlayTimer = null;
            }
            var activeScene = scenes[currentIndex];
            if (activeScene) {
              var activeVid = activeScene.querySelector('video');
              if (activeVid) {
                activeVid.pause();
              }
            }
          }
        });
      }, { threshold: 0.15 });

      observer.observe(root);
    } else {
      isVisible = true;
      playActiveVideo(currentIndex);
      startProgressTracking();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTheatreBanner);
  } else {
    initTheatreBanner();
  }
})();
